<template>
  <div>
    <app-layout>
      <template v-slot:header>
        <Header :title="$t('esl_student_module_statuses')"
                :isNewButton="checkPermission('studentmodulestatus_store')"
                @new-button-click="createFormShow"
                @filter-div-status="datatable.filterStatus = $event">
        </Header>
      </template>
      <template v-slot:header-mobile>
        <HeaderMobile :title="$t('esl_student_module_statuses')"
                      :isNewButton="checkPermission('studentmodulestatus_store')"
                      @new-button-click="createFormShow"
                      @filter-div-status="datatable.filterStatus = $event">
        </HeaderMobile>
      </template>
      <datatable-filter v-show="datatable.filterStatus" @filter="filter" @filterClear="filterClear">
        <b-row>
          <b-col sm="6">
            <b-form-group :label="$t('student')">
              <StudentsAutoComplete
                  :value="selectedPresident"
                  :clear="clear"
                  @user-input="handleSelection"
                  student-type="mentora"
              />
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group :label="$t('module_date')">
              <module-date-selectbox ref="moduleDate" v-model="datatable.queryParams.filter.module_date_id">
              </module-date-selectbox>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group :label="$t('status')">
              <parameter-selectbox code="student_module_statuses"
                                   v-model="datatable.queryParams.filter.status"></parameter-selectbox>
            </b-form-group>
          </b-col>
        </b-row>
      </datatable-filter>
      <datatable :isLoading.sync="datatable.isLoading" :columns="datatable.columns" :rows="datatable.rows"
                 :total="datatable.total" :queryParams="datatable.queryParams" :lineNumbers="false"
                 @on-page-change="onPageChange" @on-sort-change="onSortChange"
                 @on-per-page-change="onPerPageChange"
                 v-show="datatable.showTable">
      </datatable>
      <CommonModal id="createFormModal" size="md" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
        <template v-slot:CommonModalTitle>
          {{ $t('new').toUpperCase() }}
        </template>
        <template v-slot:CommonModalContent>
          <create-form @createFormSuccess="createFormSuccess"
                       v-if="formProcess=='create'"
          />
        </template>
      </CommonModal>
      <CommonModal id="updateFormModal" size="md" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
        <template v-slot:CommonModalTitle>
          {{ $t('edit').toUpperCase() }}
        </template>
        <template v-slot:CommonModalContent>
          <update-form :formId="formId"
                       @updateFormSuccess="updateFormSuccess"
                       v-if="formProcess=='update'"/>
        </template>
      </CommonModal>
    </app-layout>
  </div>
</template>
<script>
//Template
import AppLayout from "@/layouts/AppLayout"
import Header from "@/layouts/AppLayout/Header"
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile"
//Component
import DatatableFilter from "@/components/datatable/DatatableFilter";
import Datatable from "@/components/datatable/Datatable";
import CommonModal from "@/components/elements/CommonModal";
//Other
import qs from 'qs'

import CreateForm from "./CreateForm";
import UpdateForm from "./UpdateForm";
import EslStudentModuleServices from "@/services/EslStudentModuleServices";
import ModuleDateSelectbox from "@/components/interactive-fields/ModuleDateSelectbox.vue";
import StudentsAutoComplete from "@/components/interactive-fields/StudentsAutoComplete.vue";

export default {
  components: {
    StudentsAutoComplete,
    ModuleDateSelectbox,
    AppLayout,
    Header,
    HeaderMobile,

    DatatableFilter,
    Datatable,
    CommonModal,

    CreateForm,
    UpdateForm,
  },
  metaInfo() {
    return {
      title: this.$t('esl_student_module_statuses')
    }
  },
  data() {
    return {
      clear: false,
      selectedPresident: "",
      formId: 0,
      form: {},
      formProcess: null,
      datatable: {
        isLoading: false,
        columns: [
          {
            label: '',
            field: 'buttons',
            html: true,
            sortable: false,
            tdClass: 'p-0 text-center w-40 align-middle',
            buttons: [
              {
                text: this.$t('edit'),
                class: 'ri-edit-box-line',
                permission: 'studentmodulestatus_update',
                callback: (row) => {
                  this.updateFormShow(row.id);
                }
              },
              {
                text: this.$t('delete'),
                class: 'ri-delete-bin-2-line',
                permission: 'studentmodulestatus_delete',
                callback: (row) => {
                  this.delete(row.id);
                }
              },
            ]
          },
          {
            label: this.$t('first_name'),
            field: 'first_name',
            sortable: false,
          },
          {
            label: this.$t('last_name'),
            field: 'last_name',
            sortable: false,
          },
          {
            label: this.$t('module'),
            field: 'module_date_name',
            sortable: false,
          },
          {
            label: this.$t('status'),
            field: 'status_name',
            sortable: false,
          },
        ],
        rows: [],
        total: 0,
        filterStatus: true,
        showTable: false,
        queryParams: {
          filter: {},
          sort: 'id',
          page: 1,
          limit: 20
        }
      }
    }
  },
  methods: {
    filter() {
      this.datatable.queryParams.page = 1;
      this.getRows();
    },
    filterClear() {
      this.datatable.queryParams.filter = {};
      this.selectedPresident = ''
      this.clear = !this.clear;
      this.getRows();
    },
    onPageChange(params) {
      this.datatable.queryParams.page = params.currentPage;
      this.getRows();
    },
    onPerPageChange(params) {
      this.datatable.queryParams.limit = params.currentPerPage;
      this.datatable.queryParams.page = 1;
      this.getRows();
    },
    onSortChange(params) {
      const sortType = params[0].type == 'desc' ? '-' : '';
      this.datatable.queryParams.sort = sortType + params[0].field
      this.getRows();
    },
    getRows() {
      this.datatable.showTable = true;
      this.datatable.isLoading = true;

      const config = {
        params: {
          ...this.datatable.queryParams
        },
        paramsSerializer: (params) => qs.stringify(params, {encode: false})
      };

      return EslStudentModuleServices.getAll(config)
          .then((response) => {
            this.datatable.rows = response.data.data
            this.datatable.total = response.data.pagination.total
          })
          .finally(() => {
            this.datatable.isLoading = false;
          });
    },

    delete(id) {
      this.deleteModal(() => {
        EslStudentModuleServices.del(id)
            .then(response => {
              this.filter();
              this.$toast.success(this.$t('api.' + response.data.message));
            })
            .catch(error => {
              this.$toast.error(this.$t('api.' + error.data.message));
            });
      });
    },
    async createFormSuccess() {
      this.$bvModal.hide('createFormModal');
      this.getRows()
      this.formClear()
    },
    async updateFormSuccess() {
      this.$bvModal.hide('updateFormModal');
      this.getRows()
      this.formClear()
    },
    createFormShow() {
      this.formId = null
      this.form = {};
      this.formProcess = 'create'
      this.$bvModal.show('createFormModal');
    },
    updateFormShow(id) {
      this.formId = id
      this.form = {};
      this.formProcess = 'update'
      this.$bvModal.show('updateFormModal');
    },
    formClear() {
      this.formId = null
      this.formProcess = null
    },
    handleSelection(user) {
      this.datatable.queryParams.filter.student_program_id = user?.student_program_id;
      this.selectedPresident = user ? `${user.name} ${user.surname}` : '';
    },
  }
};
</script>

